import React from "react";
import moment from "moment";
import { UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimesCircle,
  faCalendarAlt
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "../../../Home/components/common/DatePicker";
import IInput from "../iInput/IInput";
import IDateProps from "./IDate.props";
import IDateState from "./IDate.state";

export default class IDate extends IInput<IDateProps, IDateState> {
  state = {
    value: null,
    isExpanded: false
  };

  componentDidMount(): void {
    if (this.props.init) {
      this.setState(
        {
          value: this.props.init
        },
        () => super.triggerInput()
      );
    } else {
      super.triggerInput();
    }
  }

  componentDidUpdate(prevProps): void {
    if (this.props.init != prevProps.init) {
      this.setState({
        value: this.props.init
      });
    }
  }

  toggleExpanded = () => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.onExpandRow) {
      this.props.onExpandRow();
    }

    this.setState({ isExpanded: !this.state.isExpanded });
  };

  onChange = date => {
    const value = date && moment(date).format("YYYY-MM-DD");
    this.props.setter(this.props.name, value);
    this.props.onChange && this.props.onChange(value);
    this.setState({ value });
  };

  renderCollapsed = () => {
    const displayValue = this.state.value
      ? moment(this.state.value).format("DD/MM/YYYY")
      : "---";

    return (
      <div
        onClick={this.toggleExpanded}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "6px 10px",
          backgroundColor: this.props.disabled ? "unset" : "#f5f5f5",
          borderRadius: "4px",
          cursor: this.props.disabled ? "default" : "pointer",
          minHeight: "32px",
          border: this.props.disabled ? "unset" : "1px solid #e0e0e0",
          transition: "all 0.2s ease",
          lineHeight: "19px"
        }}
        onMouseEnter={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#ebebeb";
          }
        }}
        onMouseLeave={e => {
          if (!this.props.disabled) {
            e.currentTarget.style.backgroundColor = "#f5f5f5";
          }
        }}
      >
        <div
          style={{
            color: this.state.value ? "#333" : "#999",
            fontSize: "14px"
          }}
        >
          {this.props.cellFormatter
            ? this.props.cellFormatter(displayValue)
            : displayValue}
        </div>
        {!this.props.disabled && (
          <FontAwesomeIcon
            icon={faCalendarAlt}
            color="#999"
            style={{
              marginLeft: "8px",
              marginBottom: "4px",
              flexShrink: 0,
              fontSize: "12px"
            }}
          />
        )}
      </div>
    );
  };

  render() {
    if (this.props.hidden) {
      return <></>;
    }

    const isExpanded = this.props.rowExpanded || this.state.isExpanded;
    const id = `${this.props.formKey || ""}-${this.props.name}`;
    const content = (
      <>
        <div style={{ display: "inline-block", width: "calc(100% - 25px)" }}>
          <DatePicker
            label={this.props.onTable ? undefined : this.props.label}
            name={this.props.name}
            id={id}
            selected={this.state.value}
            onChange={this.onChange}
            errors={
              this.props.dirty && this.props.message
                ? [this.props.message]
                : null
            }
            disabled={this.props.disabled}
          />
        </div>
        {!this.props.disabled && (
          <UncontrolledTooltip placement="top" target={`${id}-borrar`}>
            Borrar fecha
          </UncontrolledTooltip>
        )}
        <div
          id={`${id}-borrar`}
          onClick={e => {
            e.preventDefault();

            if (!this.props.disabled) {
              this.onChange(null);
            }
          }}
          style={{
            cursor: this.props.disabled ? "default" : "pointer",
            color: this.props.disabled ? "#ccc" : "#000",
            textAlign: "right",
            display: "inline-block",
            width: "24px",
            height: "24px",
            verticalAlign: this.props.onTable ? "baseline" : "top",
            paddingTop: this.props.onTable ? "0px" : "32px"
          }}
        >
          <FontAwesomeIcon icon={faTimesCircle} />
        </div>
      </>
    );

    if (this.props.onTable) {
      if (this.props.cellCollapsed && !isExpanded) {
        return (
          <td className={this.props.classCol || ""}>
            {this.renderCollapsed()}
          </td>
        );
      }
      return <td className={this.props.classCol || ""}>{content}</td>;
    }

    return <div className={this.btsClassName()}>{content}</div>;
  }
}
